
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Games',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Turn-based PvP for skins: gear up and outplay your rival',
    rushMidCta: 'Rush the mid',
    rouletteTitle: 'Russian Roulette',
    rouletteDescription: 'R8 cylinder, last one standing takes the bank',
    rouletteCta: 'Play',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Test your luck against other players',
    contractsTitle: 'Contracts',
    contractsDescription: 'Exchange items for better ones',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Upgrade items with a chance for rare skins',
    auctionsTitle: 'Auctions',
    auctionsDescription: 'Participate in auctions and win items',
    shopTitle: 'Shop',
    shopDescription: 'Buy items',
    comingSoon: 'Coming Soon',
    maintenanceBadge: 'Updating…',
    caseBattlesCta: 'Fight',
    contractsCta: 'Exchange',
    upgradeCta: 'Upgrade',
    shopCta: 'Open',
  },
  ru: {
    title: 'Игры',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Пошаговый PvP за скины: закупись и переиграй соперника',
    rushMidCta: 'Зарашить мид',
    rouletteTitle: 'Русская рулетка',
    rouletteDescription: 'Барабан R8, выживший забирает банк',
    rouletteCta: 'Играть',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Проверь удачу против других игроков',
    contractsTitle: 'Контракты',
    contractsDescription: 'Обменивай предметы на более ценные',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Улучшай предметы с шансом на редкие скины',
    auctionsTitle: 'Аукционы',
    auctionsDescription: 'Участвуй в аукционах и выигрывай предметы',
    shopTitle: 'Магазин',
    shopDescription: 'Покупай предметы',
    comingSoon: 'Скоро',
    maintenanceBadge: 'Обновление…',
    caseBattlesCta: 'В бой',
    contractsCta: 'Обменять',
    upgradeCta: 'Улучшить',
    shopCta: 'Открыть',
  },
  uz: {
    title: 'Oʻyinlar',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: "Skinlar uchun navbatma-navbat PvP: qurollan va raqibingni ort",
    rushMidCta: 'Midni rush qilish',
    rouletteTitle: 'Rus ruletkasi',
    rouletteDescription: "R8 barabani, omon qolgan bankni oladi",
    rouletteCta: 'Oʻynash',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Boshqa oʻyinchilarga qarshi omadingizni sinab koʻring',
    contractsTitle: 'Kontraktlar',
    contractsDescription: 'Buyumlarni qimmatroqlariga almashtiring',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Buyumlarni kamyob skinlarga yaxshilash imkoniyati bilan',
    auctionsTitle: 'Auktsionlar',
    auctionsDescription: 'Auktsionlarda qatnashing va buyumlar yuting',
    shopTitle: 'Doʻkon',
    shopDescription: 'Buyumlarni sotib oling',
    comingSoon: 'Tez kunda',
    maintenanceBadge: 'Yangilanmoqda…',
    caseBattlesCta: 'Jang',
    contractsCta: 'Almashtirish',
    upgradeCta: 'Yaxshilash',
    shopCta: 'Ochish',
  },
  fa: {
    title: 'بازی‌ها',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'PvP نوبتی برای اسکین: تجهیز شو و حریفت را ببر',
    rushMidCta: 'بزن به مید',
    rouletteTitle: 'رولت روسی',
    rouletteDescription: 'خشاب R8، آخرین بازمانده بانک را می‌برد',
    rouletteCta: 'بازی کن',
    caseBattlesTitle: 'نبرد کیس',
    caseBattlesDescription: 'شانست را مقابل بازیکنان دیگر امتحان کن',
    contractsTitle: 'قراردادها',
    contractsDescription: 'آیتم‌ها را با آیتم بهتر عوض کن',
    upgradeTitle: 'ارتقا',
    upgradeDescription: 'آیتم‌ها را ارتقا بده و شانس اسکین کمیاب بگیر',
    auctionsTitle: 'حراج‌ها',
    auctionsDescription: 'در حراج شرکت کن و آیتم ببر',
    shopTitle: 'فروشگاه',
    shopDescription: 'آیتم بخر',
    comingSoon: 'به‌زودی',
    maintenanceBadge: 'در حال به‌روزرسانی…',
    caseBattlesCta: 'بجنگ',
    contractsCta: 'عوض کن',
    upgradeCta: 'ارتقا بده',
    shopCta: 'باز کن',
  },
});
